import { DynamicClassMapper, Style } from "../Style.types";

export function getDynamicClassStyle(className: string): Style | null {
  const dynamicIndicator = className.indexOf("-{");
  if (dynamicIndicator < 0) return null;

  if (!className.endsWith("}")) return null;

  const propIndicator = className.slice(0, dynamicIndicator);
  const value = className.slice(dynamicIndicator + 2, className.length - 1);

  const styleProp = DynamicClassMapper[propIndicator];
  if (!styleProp) return null;

  // return string or number %, auto values
  if (styleProp.type === "string" || value.includes("%") || value == "auto") return { [styleProp.prop]: value };

  // parse number value
  const numValue = parseFloat(value);
  return { [styleProp.prop]: numValue };
}
